import { Box } from "@mui/material"
import { Chapter, Report } from "graphql/types"
import { useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"
import { setGlobalReportContext } from "utils/addToReport"
import { findChapterById } from "utils/findChapterByID"
import { ReportContent } from "./ReportContent"

type ReportMiddleBoxProps = {
  report: Report
  updateReport: (updatedReport: Report) => void
}

export const ReportMiddleBox = (props: ReportMiddleBoxProps) => {
  const { report, updateReport } = props
  const [chapter, setChapter] = useState<Chapter | null>(null)
  const [searchParams] = useSearchParams()
  const chapterID = searchParams.get("chapterID")

  useEffect(() => {
    if (chapterID) {
      const newChapter = findChapterById(report.chapter, chapterID)
      setChapter(newChapter)
    }
  }, [report.chapter, chapterID])

  // Set global report context for adding DataNodes from other components
  useEffect(() => {
    setGlobalReportContext(report, chapterID, updateReport)
  }, [report, chapterID, updateReport])

  return (
    <Box
      sx={{
        flex: 2,
        border: "solid grey",
        borderWidth: "0 4px 0 4px",
        height: "calc(100vh - 100px)",
        padding: 1,

        overflow: "auto",
      }}
    >
      {chapter && <ReportContent chapter={chapter} report={report} updateReport={updateReport} />}
    </Box>
  )
}
